import { render, staticRenderFns } from "./ImageToLayoutCreatePage.vue?vue&type=template&id=5e2b3ec4&scoped=true&"
import script from "./ImageToLayoutCreatePage.vue?vue&type=script&lang=js&"
export * from "./ImageToLayoutCreatePage.vue?vue&type=script&lang=js&"
import style0 from "./ImageToLayoutCreatePage.vue?vue&type=style&index=0&id=5e2b3ec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2b3ec4",
  null
  
)

export default component.exports